import script from "./HomeDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&setup=true&lang=js"

import "./HomeDashboard.vue?vue&type=style&index=0&id=6e320458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e320458"]])

export default __exports__